module.exports = __webpack_public_path__ + "static/img/aqzs06.9568ae61.jpg";